import { TIMING } from '../config/timing.js';
/**
 * Die Wartezeit bis zum nächsten Verbindungsversuch.
 *
 * ## Warum ansteigend
 *
 * Auftrag, Abschnitt 9. Fällt der Server aus oder wird er neu gestartet,
 * verlieren **alle** Fahrzeuge einer Ausfahrt im selben Augenblick ihre
 * Verbindung. Versuchten sie es alle im Sekundentakt weiter, träfe den
 * wiederkehrenden Server eine Kolonne auf einmal — und er ginge ein zweites Mal
 * in die Knie. Die Wartezeit verdoppelt sich deshalb je Versuch, bis
 * `reconnectMaxMs`.
 *
 * ## Warum die Streuung
 *
 * Ohne sie warten alle **gleich** lang und kommen wieder gemeinsam. Die
 * Streuung zieht die Versuche auseinander. Sie wird von außen hereingegeben,
 * damit diese Rechnung prüfbar bleibt — der Zufall gehört an den Rand.
 *
 * ## Wer sie benutzt
 *
 * Die Weboberfläche und der Fahrsimulator. Bis zum 29.08.2026 stand die Formel
 * nur im Browser, und der Simulator verband sich überhaupt nicht wieder: Ein
 * Ausrollen mitten in einem Lauf beendete ihn stillschweigend, und niemand sah
 * es, weil vier Fahrzeuge einfach aufhörten zu melden.
 */
export function reconnectDelayMs(versuch, streuung = Math.random()) {
    const stufe = Math.max(0, Math.floor(versuch));
    const warten = Math.min(TIMING.reconnectBaseMs * TIMING.reconnectFactor ** stufe, TIMING.reconnectMaxMs);
    return warten + Math.min(Math.max(streuung, 0), 1) * TIMING.reconnectJitterMs;
}
//# sourceMappingURL=wiederverbinden.js.map